import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router/composables';

import {
  NavBar,
  Heading,
  Grid,
  LoaderIndicator,
  HelperViewStatus
} from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons/BackButton';
import { PortfolioCardV2 } from '@/modules/wealth/components/PortfolioCardV2';

import { getPortfoliosToWithdraw } from '@/modules/wealth/services/withdraw-v2';
import { IPortfolioList, PortfolioCategories } from '@/types/models/Portfolio';


export default /*#__PURE__*/_defineComponent({
  __name: 'WealthWithdraw',
  setup(__props) {

const router = useRouter();

const portfolioList = ref<IPortfolioList[]>([]);
const isLoading = ref(false);
const hasError = ref(false);

function gotToWithdraw(portfolio: IPortfolioList) {
  const routerName: Record<PortfolioCategories, string> = {
    [PortfolioCategories.Custom]: 'wealthProductWithdrawal',
    [PortfolioCategories.VariableIncome]: 'variableIncomeWithdraw',
    [PortfolioCategories.WarrenManagement]: 'withdrawByPortfolio'
  };

  router.push({
    name: routerName[portfolio.type],
    params: { id: portfolio.id }
  });
}

async function fetchPortfolios() {
  isLoading.value = true;
  hasError.value = false;

  try {
    portfolioList.value = await getPortfoliosToWithdraw();
  } catch (error) {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

onMounted(() => {
  fetchPortfolios();
});

return { __sfc: true,router, portfolioList, isLoading, hasError, gotToWithdraw, fetchPortfolios, NavBar, Heading, Grid, LoaderIndicator, HelperViewStatus, BackButton, PortfolioCardV2 }
}

})